
import { useNavigate } from "react-router-dom";
import MasterAssessmentCard from "./MasterAssessmentCard";
import { useContext, useEffect } from "react";
import AuthContext from "../../../../auth/AuthContext";

const MasterAssessment = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);


  useEffect(()=>{
    const assessmentAccess = authContext.getPermissions("assessmentsmaster");
        if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
            navigate("/");
        }
      },[authContext, navigate]);


  return (
    <div className="space-y-4 mt-4">
    <MasterAssessmentCard />
    </div>
  );
};

export default MasterAssessment;